var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUnlimSubsc = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 76,
  height: 76,
  viewBox: "0 0 76 76",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 76,
  height: 76
}, /*#__PURE__*/React.createElement("rect", {
  width: 76,
  height: 76,
  rx: 6,
  fill: "#E4E8EC"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.8877 10.2472C32.574 10.2472 29.8877 12.9335 29.8877 16.2472V30.7416H15.3933C12.0796 30.7416 9.39331 33.4279 9.39331 36.7416V59.7528C9.39331 63.0665 12.0796 65.7528 15.3933 65.7528H40.1124C43.4261 65.7528 46.1124 63.0665 46.1124 59.7528V45.2584H60.6068C63.9205 45.2584 66.6068 42.5721 66.6068 39.2584V16.2472C66.6068 12.9335 63.9205 10.2472 60.6068 10.2472H35.8877ZM46.1124 45.2584V36.7416C46.1124 33.4279 43.4261 30.7416 40.1124 30.7416H29.8877V39.2584C29.8877 42.5721 32.574 45.2584 35.8877 45.2584H46.1124Z",
  fill: "#3983F2"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnlimSubsc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unlimSubsc.e8ec1ff6.svg";
export { ForwardRef as ReactComponent };